<div class="snackbar-container">
    <img src="{{ data.type }}.gif" width="25" height="25">
    <div>
        <!-- <span class="snackbar-message"><b>¡Hecho!</b>{{ "\n" }}</span> -->
        <span class="snackbar-message">{{ data.message }}</span>
    </div>
    <button mat-icon-button (click)="close()" class="snackbar-close">
        <mat-icon>close</mat-icon>
    </button>
</div>